import './App.css'
import { Layout } from './masterComponents/layout'
import { Route, Routes } from 'react-router-dom'
import { Planning } from './pageComponents/planning/Planning'
import { Implementation } from './pageComponents/implementation/Implementation'
// import { Resources } from './Resources'
// import { Reports } from './Reports'
import { AuthProvider } from '../contextProviders/AuthProvider'
import { HomePage } from './HomePage'
import { UserDetailsPage } from './pageComponents/userProfile/UserDetailsPage'
import { ProtectedRoute } from './masterComponents/ProtectedRoute'
import { OrganizationDetails } from './pageComponents/organizations/OrganizationDetails'
import { AuthFunctions, hasPermission } from '../utils/permissions'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './ToastifyOverrides.css'
import { AppRoutes } from './Routes'
import { Administration } from './pageComponents/organizations/Administration'
import { BreadcrumbProvider } from '../contextProviders/BreadcrumbProvider'
import { CETAClassroomList } from './pageComponents/CETAs/CETAClassroomList'
import { CETAOverview } from './pageComponents/CETAs/CETAOverview'
import { CETASnapshot } from './pageComponents/CETAs/CETASnapshot'
import { CETAReconcile } from './pageComponents/CETAs/CETAReconcile'
import { CETAPlanSectionPrint } from './pageComponents/CETAs/Plan/CETAPlanSectionPrint'
import { PlanningInstance } from './pageComponents/planning/PlanningInstance'
import { PlanningDetails } from './pageComponents/planning/PlanningDetails'
import { ThemeProvider } from '@mui/system'
import { defaulTheme } from '../theme'
import {
  PlanningPriorityActivitiesPlanOrganization
} from './pageComponents/planning/priorityActivities/PlanningPriorityActivitiesPlanOrganization'
import {
  PlanningPriorityActivitiesPlanOrganizationPriority
} from './pageComponents/planning/priorityActivities/PlanningPriorityActivitiesPlanOrganizationPriority'
import { UserProfile } from './pageComponents/userProfile/UserProfile'
import { ImplementationInstance } from './pageComponents/implementation/ImplementationInstance'
import { ImplementationCeta } from './pageComponents/implementation/ImplementationCeta'
import { ImplementationDetails } from './pageComponents/implementation/ImplementationDetails'

function App (): JSX.Element {
  return (
    <AuthProvider>
      <ThemeProvider theme={defaulTheme}>
        <Layout>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            closeOnClick
            draggable={false}
            theme="colored"
          />
          <BreadcrumbProvider>
            <Routes>
              <Route
                path={AppRoutes.HOME}
                element={<HomePage />}
              />
              <Route element={
                <ProtectedRoute allow={(user) => user != null} />
               }
              >
                <Route
                  path={AppRoutes.USER_PROFILE}
                  element={<UserProfile />}
                />
              </Route>

              <Route element={
                <ProtectedRoute allow={(user) => !user.isOrgOnboarding} />}
              >
                { process.env.REACT_APP_HIDE_PLANNING !== 'true' &&
                  <Route element={
                    <ProtectedRoute allow={(user) =>
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_ADMINISTRATION_EDIT) ||
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_REVIEW) ||
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_REVIEW_EDIT) ||
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_ADMINISTRATION) ||
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_ADMINISTRATION_EDIT) ||
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_CONTRIBUTION) ||
                      hasPermission(user, AuthFunctions.ANNUAL_PLANNING_CONTRIBUTION_EDIT)
                      }
                    />
                  }
                  >
                    <Route
                      path={AppRoutes.PLANNING}
                      element={<Planning />}
                    />

                    <Route
                      path={AppRoutes.PLANNING_INSTANCE}
                      element={<PlanningInstance />}
                    />

                    <Route
                      path={AppRoutes.PLANNING_DETAILS}
                      element={<PlanningDetails />}
                    >
                      <Route
                        path={AppRoutes.PLANNING_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION}
                        element={<PlanningPriorityActivitiesPlanOrganization />}
                      />

                      <Route
                        path={AppRoutes.PLANNING_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY}
                        element={<PlanningPriorityActivitiesPlanOrganizationPriority />}
                      />
                    </Route>
                  </Route>
                }

                <Route element={
                  <ProtectedRoute allow={(user) =>
                    hasPermission(user, AuthFunctions.CETA_PARTICIPATION) ||
                    hasPermission(user, AuthFunctions.ANNUAL_PLANNING_REVIEW) ||
                    hasPermission(user, AuthFunctions.ANNUAL_PLANNING_REVIEW_EDIT) ||
                    hasPermission(user, AuthFunctions.ANNUAL_PLANNING_ADMINISTRATION) ||
                    hasPermission(user, AuthFunctions.ANNUAL_PLANNING_ADMINISTRATION_EDIT) ||
                    hasPermission(user, AuthFunctions.ANNUAL_PLANNING_CONTRIBUTION) ||
                    hasPermission(user, AuthFunctions.ANNUAL_PLANNING_CONTRIBUTION_EDIT)
                  }
                  />}
                >
                  <Route
                    path={AppRoutes.IMPLEMENTATION}
                    element={<Implementation />}
                  />

                  <Route
                    path={AppRoutes.IMPLEMENTATION_INSTANCE}
                    element={<ImplementationInstance />}
                  />

                  <Route
                    path={AppRoutes.IMPLEMENTATION_CETA}
                    element={<ImplementationCeta />}
                  />

                  <Route
                    path={AppRoutes.IMPLEMENTATION_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION}
                    element={<PlanningPriorityActivitiesPlanOrganization />}
                  />

                  <Route
                    path={AppRoutes.IMPLEMENTATION_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY}
                    element={<PlanningPriorityActivitiesPlanOrganizationPriority />}
                  />

                  <Route
                    path={`${AppRoutes.IMPLEMENTATION_DETAILS}/*`}
                    element={<ImplementationDetails />}
                  />
                </Route>

                {/* <Route
                  path={AppRoutes.RESOURCES}
                  element={<Resources />}
                /> */}

                {/* <Route element={
                  <ProtectedRoute allow={(user) =>
                    hasPermission(user, AuthFunctions.REPORTS)}
                  />}
                >
                  <Route
                    path={AppRoutes.REPORTS}
                    element={<Reports />}
                  />
                </Route> */}

                <Route element={
                  <ProtectedRoute allow={(user) =>
                    hasPermission(user, AuthFunctions.CETA_PARTICIPATION)}
                  />}
                >
                  <Route
                    path={AppRoutes.CETA_CLASSROOMS}
                    element={<CETAClassroomList />}
                  />

                  <Route
                    path={AppRoutes.CETA_OVERVIEW}
                    element={<CETAOverview />}
                  />

                  <Route
                    path={AppRoutes.CETA_SECTION_PRINT}
                    element={<CETAPlanSectionPrint />}
                  />

                  <Route
                    path={AppRoutes.CETA_SNAPSHOT}
                    element={<CETASnapshot />}
                  />

                  <Route
                    path={AppRoutes.CETA_RECONCILE}
                    element={<CETAReconcile />}
                  />
                </Route>
              </Route>

              <Route element={
                <ProtectedRoute allow={(user) =>
                  hasPermission(user, AuthFunctions.PROJECT_SETTINGS) ||
                  hasPermission(user, AuthFunctions.RCN_MANAGEMENT) ||
                  hasPermission(user, AuthFunctions.ISD_MANAGEMENT) ||
                  hasPermission(user, AuthFunctions.DISTRICT_MANAGEMENT) ||
                  hasPermission(user, AuthFunctions.RCN_ADMINISTRATION) ||
                  hasPermission(user, AuthFunctions.ISD_ADMINISTRATION) ||
                  hasPermission(user, AuthFunctions.DISTRICT_ADMINISTRATION)}
                />}
              >
                <Route
                  path={AppRoutes.ADMINISTRATION}
                  element={<Administration />}
                />
                <Route
                  path={AppRoutes.ORGANIZATION_DETAILS}
                  element={<OrganizationDetails />}
                />
                <Route
                  path={AppRoutes.USER_DETAILS}
                  element={<UserDetailsPage />}
                />
              </Route>
            </Routes>
          </BreadcrumbProvider>
        </Layout>
      </ThemeProvider>
    </AuthProvider>
  )
}

export default App
